export default __webpack_public_path__ + "static/media/result2.93c3f956.png";